import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { Events, LoadingController, NavController, ToastController } from 'ionic-angular';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ApiService } from '../../../../services/api';
import { AnnouncerSheetsReport } from './report-announcer-sheets';
import { AlphaReport } from './report-alpha';
import { CarryOversReport } from './report-carryovers';
import { SidepotReport } from './report-sidepot';
import { ShowSheetsReport } from './report-show-sheets';
import { CheckInReport } from './report-check-in';
import { SummaryReport } from './report-summary';
import { ResultsReport } from './report-results';
import { PointsReport } from './report-points';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReportsService } from '../../../../services/reports.service';
import { LoadCardsReportComponent } from './report-load-cards';
import { PrintService } from '../../../../services/print-service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { PointStatsReportComponent } from './points/point-stats-report.component';
import { ContestantPaidReport } from './report-contestant-paid-sheet';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'staff-reports',
    templateUrl: 'reports.html'
})
export class ReportsSection implements OnInit, OnDestroy {
    @ViewChild('points') points: PointsReport;
    @ViewChild('results') results: ResultsReport;
    @ViewChild('announcer') announcer: AnnouncerSheetsReport;
    @ViewChild('alpha') alpha: AlphaReport;
    @ViewChild('carryovers') carryovers: CarryOversReport;
    @ViewChild('sidepot') sidepot: SidepotReport;
    @ViewChild('show') show: ShowSheetsReport;
    @ViewChild('checkin') checkin: CheckInReport;
    @ViewChild('summary') summary: SummaryReport;
    @ViewChild('loadCardsComponent') loadCardsComponent: LoadCardsReportComponent;
    @ViewChild('reportTypeSelect') reportTypeSelect: ElementRef;
    @ViewChild('pointStatsReport') pointStats: PointStatsReportComponent
    @ViewChild('paidItems') paidItems: ContestantPaidReport;

    _rodeo: Rodeo;
    _viewMode: string = 'overview';

    selectedRodeoEvent: RodeoEvent;

    popoverActive: boolean;
    loadingData: boolean;

    batches: any[] = [];
    schedules: RodeoEventSchedule[] = [];

    cleanedSchedules: RodeoEventSchedule[][] = [];

    hasExhibitions: boolean;
    hasSidepots: boolean;

    options: FormGroup;
    isLoading = false;
    printing = false;

    reports = [
        { type: 'daysheet', label: 'Day Sheets', showRoundFilter: true, disableFilters: false, hasCsv: true, hasPdf: true, canPrint: false },
        { type: 'secretary', label: 'Secretary Sheets', showRoundFilter: true, disableFilters: false, hasCsv: true, hasPdf: false, canPrint: true },
        { type: 'secretary-ipra', label: 'Secretary (IPRA)', showRoundFilter: false, disableFilters: false, hasCsv: false, hasPdf: false, canPrint: true },
        { type: 'judge', label: 'Judge/Timer Sheets', showRoundFilter: true, disableFilters: false, hasCsv: true, hasPdf: false, canPrint: true },
        { type: 'load-cards', label: 'Load Cards', showRoundFilter: false, disableFilters: false, hasCsv: false, hasPdf: true, canPrint: false },
        { type: 'turnout', label: 'Turnout List', showRoundFilter: false, disableFilters: false, hasCsv: true, hasPdf: false, canPrint: true },
        { type: 'no-pref', label: 'No Preference', showRoundFilter: false, disableFilters: true, hasCsv: false, hasPdf: false, canPrint: true },
        { type: 'double-book', label: 'Double Booked', showRoundFilter: false, disableFilters: true, hasCsv: false, hasPdf: false, canPrint: true },
        { type: 'unpaid', label: 'Unpaid Registrations', showRoundFilter: false, disableFilters: true, hasCsv: false, hasPdf: false, canPrint: true },
        { type: 'exhibition', label: 'Exhibition Report', showRoundFilter: false, disableFilters: true, hasCsv: false, hasPdf: false, canPrint: true },
        { type: 'long-form', label: 'Long Form', showRoundFilter: false, disableFilters: false, hasCsv: false, hasPdf: true, canPrint: false }
    ];


    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;
            this.schedules = [];

            this._rodeo.rodeoEvents.forEach(rodeoEvent => {
                if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding'
                || rodeoEvent.eventType === 'BarebackRiding')
                    rodeoEvent.roughStock = true;

                if (!this.selectedRodeoEvent)
                    this.selectedRodeoEvent = rodeoEvent;

                rodeoEvent.schedules.forEach(schedule => {
                    if (this.schedules.filter(x => x.name === schedule.name && x.scheduledDate == schedule.scheduledDate).length == 0)
                        this.schedules.push(schedule);
                });

                if (rodeo.exhibitions.length > 0) {
                    this.hasExhibitions = true;
                    console.log("found exhibitions on event");
                }

                this.hasSidepots = rodeoEvent.sidepots.length > 0;
            });

            this.schedules.sort((a, b) => {
                let aDate = new Date(a.scheduledDate);
                let bDate = new Date(b.scheduledDate);

                return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
            });
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
            
            if (viewMode == 'points') {
                this.points.load();
            } else if (viewMode == 'judge') {
                // this.judgeTimer.load();
            } else if (viewMode == 'announcer') {
                this.announcer.load();
            } else if (viewMode == 'results') {
                this.results.load();
            } else if (viewMode == 'alpha') {
                this.alpha.load();
            } else if (viewMode == 'carryovers') {
                this.carryovers.load();
            } else if (viewMode == 'exhibition') {
                // this.exhibition.load();
            } else if (viewMode == 'sidepot') {
                this.sidepot.load();
            } else if (viewMode == 'secretary-ipra') {
                // this.secretaryIpra.load();
            } else if (viewMode == 'secretary') {
                // this.secretary.load();
            } else if (viewMode == 'show') {
                this.show.load();
            } else if (viewMode == 'checkin') {
                this.checkin.load();
            } else if (viewMode == 'summary') {
                this.summary.load();
            } else if (viewMode == 'paidItems') {
                this.paidItems.ngOnInit();
            }
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    private subscriptions: Subscription[] = [];

    constructor(private printService:PrintService, private fb: FormBuilder, public api: ApiService, private events: Events, private reportService: ReportsService, private datePipe: DatePipe, private toast: ToastController, public dateHelper: DateHelperService) { 
        this.events.subscribe("WinnersChanged", (data) => this.points.load());
        this.events.subscribe("TeamsChanged", (data) => this.points.mapTeams());
    }

    ngOnInit() {
        if (this.rodeo.stallsAvailable > 0) {
            if (this.reports.findIndex(x => x.type == 'stalls') < 0) {
                this.reports.push({
                    type: 'stalls',
                    label: 'Stalls',
                    showRoundFilter: false,
                    disableFilters: true,
                    hasCsv: true,
                    hasPdf: true,
                    canPrint: false
                });
            }
        }   
        
        if (this.rodeo.rvsAvailable > 0) {
            if (this.reports.findIndex(x => x.type == 'rvs') < 0) {
                this.reports.push({
                    type: 'rvs',
                    label: 'RVs',
                    showRoundFilter: false,
                    disableFilters: true,
                    hasCsv: true,
                    hasPdf: true,
                    canPrint: false
                });
            }
        }

        this.reports = this.reports.sort((a,b) => {
            return a.label > b.label ? 1 : -1;
        });

        this.options = this.fb.group({
            rodeoId: this.rodeo.id,
            rodeoEventId: 0,
            scheduleName: '',
            round: 1,
            
            cardPaperSize: 2,
            printLandscape: false,
            notateNonMembers: false,
            numOfCopies: 1,

            //these are not sent to the server
            reportType: this.reports[0],
            schedules: [this.schedules],
            rodeoEvents: [this.rodeo.rodeoEvents],
            rounds: [[1]]
        });

        this.subscriptions.push(
            this.options.get('reportType').valueChanges.subscribe(e => this.reportTypeSelected())
        );

        this.subscriptions.push(
            this.options.get('rodeoEventId').valueChanges.subscribe(e => this.rodeoEventSelected())
        );
        
        this.subscriptions.push(
            this.options.get('scheduleName').valueChanges.subscribe(e => this.getRodeoEventsBySchedule())
        );

        this.subscriptions.push(
            this.printService.printing.subscribe(printing => this.printing = printing)
        );

        this.getRodeoEventsBySchedule();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    ionViewDidEnter() {        
        this.reportTypeSelect.nativeElement.click();
    }

    async download(mode: 'pdf' | 'csv') {
        const options = this.options.value;
        console.log('print options', options);
        let promise: Promise<any>;
        switch(options.reportType.type) {
            case 'daysheet':
                promise = this.reportService.getDaySheets(mode, options);
                break;
            case 'load-cards':
                //save load order if updated
                if (this.loadCardsComponent.loadOrderUpdated) {
                    if (!await this.loadCardsComponent.saveLoadOrder()) {
                        return;
                    }
                }

                //add pen labels to print options
                options.penLabels = this.loadCardsComponent.penLabels;
                options.maxLivestockPerPen = this.loadCardsComponent.maxLivestockPerPen;

                promise = this.reportService.getLoadCardsPdf(options);
                break;
            case 'secretary':
            // case 'secretary-ipra':
                promise = this.reportService.getSecretarySheet(options);
                break;
            case 'judge':
                promise = this.reportService.getJudgeSheets(options);
                break;
            case 'turnout':
                promise = this.reportService.getTurnoutCsv(options);
                break;
            case 'long-form':
                if (options.rodeoEventId == 0) {
                    this.toast.create({
                        message: 'Event/Class is required for this report.',
                        duration: 2500,
                    }).present();
                    return;
                }
                promise = this.reportService.getLongFormPdf(options);
                break;
            case 'stalls':
            case 'rvs':
                promise = this.reportService.getReservationReport(options, options.reportType.type, mode);
                break;
        }

        if (!!promise) {
            this.isLoading = true;
            try {
                await promise;
            } catch (err) {
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        }
    }

    async print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        await this.printService.print(this.getDocumentTitle() + ' - ' + this.options.value.reportType.label);
        this.popoverActive = false;
    }

    private reportTypeSelected() {
        this.resetOptionsAndSettings();

        const filtersToDisable = [
            this.options.get('rodeoEventId'),
            this.options.get('scheduleName')
        ];

        if (this.options.value.reportType.disableFilters) {
            filtersToDisable.forEach(x => x.disable());
        } else {
            filtersToDisable.forEach(x => x.enable());
        }
    }

    private rodeoEventSelected() {
        if (this.options.value.scheduleName) {
            this.getRodeoSchedules();
        }
    }

    private getRodeoEventsBySchedule() {
        let rodeoEvents = [];
        if (this.options.value.scheduleName) {
            this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                if (rodeoEvent.schedules.findIndex(schedule => schedule.name == this.options.value.scheduleName) >= 0) {
                    rodeoEvents.push(rodeoEvent);
                }
            });
        } else {
            rodeoEvents = this.rodeo.rodeoEvents;
        }

        this.options.get('rodeoEvents').patchValue(rodeoEvents, {emitEvent: false});

        //set rounds array
        let maxRounds = 1;
        rodeoEvents.forEach((rodeoEvent) => {
            maxRounds = Math.max(maxRounds, +rodeoEvent.rounds + (rodeoEvent.shortGo ? +1 : +0));
        });

        const rounds = [];
        for (var i = 1; i <= maxRounds; i++) {
            rounds.push(i);
        }
        
        this.options.get('rounds').patchValue(rounds, {emitEvent: false});
    }

    private getRodeoSchedules() {
        const scheduleMap = new Map<string, RodeoEventSchedule>();
        this.rodeo.rodeoEvents.forEach(rodeoEvent => {
            if (this.options.value.rodeoEventId == 0 || this.options.value.rodeoEventId > 0 && this.options.value.rodeoEventId == rodeoEvent.id) {
                rodeoEvent.schedules.forEach(schedule => {
                    if (!scheduleMap.has(schedule.name)) {
                        scheduleMap.set(schedule.name, schedule);
                    }
                });
            }
        });

        this.schedules = [...scheduleMap.values()];
    }

    private resetOptionsAndSettings() {
        this.options.patchValue({
            rodeoEventId: 0,
            round: 1,
            scheduleName: '',
            rodeoEvents: this.rodeo.rodeoEvents,
            schedules: this.schedules,

            cardPaperSize: 2,
            printLandscape: false,
            notateNonMembers: false,
            numOfCopies: 1,
        }, {emitEvent: false});
    }

    private getDocumentTitle(fileEnding: string = undefined) {
        if (this.rodeo) {
            let docTitle = this.rodeo.name;
            if (this.options.value.rodeoEventId) {
                docTitle += ` - ${this.rodeo.rodeoEvents.find(x => x.id == this.options.value.rodeoEventId).displayName}`;
            }
    
            docTitle += this.getScheduleDisplay();
    
            if (fileEnding) {
                docTitle += fileEnding
            }
    
            return docTitle;
        } else {
            return '';
        }
    }

    private getScheduleDisplay() {
        let scheduleName = '';
        if (this.options.value.scheduleName) {
            scheduleName = this.options.value.scheduleName;
            const schedule = this.options.value.schedules.find(x => x.name == scheduleName);
            scheduleName += ` ${this.datePipe.transform(this.dateHelper.formatDateToSelectedTimeZone(schedule.scheduledDate, this.rodeo.rodeoTimezone), 'EE MM/dd h:mm a')}`;
        } else {
            scheduleName = 'All Schedules'
        }

        return scheduleName;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/reports.ts